'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { EgovApplicationPage } from './-components/EgovApplicationPage';
export const Route = createFileRoute('/_staff/labor-core/_egov-mock/egov-application/')({
  component: EgovApplicationPage
});